import { Button, Dropdown, Icon } from '@usitsdasdesign/dds-react';
import Heading from 'atoms/Heading';
import Text from 'atoms/Text';
import PropTypes from "prop-types";
import FilterContext from './FilterContext';

function Actions({ title, titleType = 'h4', actionItems = [], fixedActionItems = [], className, isTotalCount, totalCountText, children, filters, sortItems, handleFilterSelection, handleSortSelection, onShowSavedFilters, titleActionDrop, contextPosition, disableSave, moreActionRight, moreActionLeft="", wrapperClass="", filterWrapper=""  }) {
    const getFilterType = (actionItem, type, i) => {
        switch (type) {
            case 'Button':
                return (
                    <Button
                        key={i}
                        ariaLabel="Button"
                        icon={actionItem.icon}
                        kind={actionItem.kind}
                        label={actionItem?.label}
                        size="l"
                        color={actionItem.color}
                        onClick={actionItem.onClick}
                        className={actionItem?.className}
                        isDisabled={actionItem?.isDisabled}
                    />
                );
            case 'ButtonWithContext':
                return (
                    <FilterContext
                        key={i}
                        title={actionItem.label}
                        icon={actionItem.icon}
                        isDisabled={actionItem?.isDisabled}
                        kind={actionItem.kind}
                        label={actionItem?.label}
                        size="l"
                        color={actionItem.color}
                        className={actionItem?.className}
                        type={actionItem?.type}
                        menuItems={actionItem?.type === 'sorting' ? sortItems : filters}
                        onItemsSelect={actionItem?.type === 'sorting' ? handleSortSelection : handleFilterSelection}
                        onShowSavedFilters={onShowSavedFilters}
                        contextPosition={contextPosition}
                        disableSave={disableSave}
                    />
                )
            case 'Dropdown':
                return (
                    <Dropdown
                        ariaLabel="Dropdown"
                        color={actionItem?.color || 'green'}
                        label={actionItem?.label}
                        dropdownItems={actionItem?.items}
                        kind={actionItem?.kind}
                        onChange={(item) => {
                            item.onSelectedItem(item);
                        }}
                        size="l"
                        stickerOptions={{
                            width: 150
                        }}
                        className={actionItem?.className}
                    />
                );
                case 'Component':
                    return actionItem.component;
                    
            default:
                return (
                    <div
                        key={i}
                        className={`flex items-center gap-x-1 justify-center cursor-pointer  hover:opacity-60 ${actionItem.className || ''}`}
                        onClick={actionItem.onClick}
                    >
                        <Icon
                            icon={actionItem.icon}
                            className='w-4 h-4'
                            color={actionItem.color}
                        />
                        <Text className='hidden md:block'>{actionItem?.label}</Text>
                    </div>
                )
        }
    }
    
    
    return (
        <div className={`mb-4 ${className}`}>
            <div className={`flex flex-col md:flex-row flex-wrap gap-2 md:gap-4 md:items-center justify-between ${wrapperClass}`}>
                <div className='flex items-center flex-wrap gap-2'>
                    <Heading type={titleType}>{title}</Heading>
                    {titleActionDrop}
                </div>
                <div className={`flex flex-wrap gap-2 items-center justify-between md:justify-end ${filterWrapper}`}>
                    {moreActionLeft}
                    <div className='flex flex-wrap items-center gap-2'>
                        {fixedActionItems.map((actionItem, i) => getFilterType(actionItem, actionItem.ariaLabel, i))}
                    </div>
                    <div className='flex flex-wrap items-center gap-2'>
                        {actionItems.map((actionItem, i) => getFilterType(actionItem, actionItem.ariaLabel, i))}
                    </div>
                    {moreActionRight}
                </div>
            </div>
            <div className={`filters-to-be-applied`}>
                {children}
            </div>
            {
                isTotalCount && <Heading type='h6' className='mt-4'>{totalCountText}</Heading>
            }
        </div>

    )
};

Actions.defaultProps = {
    actionItems: [],
    className: '',
    searchSubmitted: (e) => false,
    isSearch: true,
    isTotalCount: true,
    totalCountText: '2/50 Projects/Engagements found'
}

Actions.propTypes = {
    actionItems: PropTypes.arrayOf(PropTypes.shape({})),
    className: PropTypes.string,
    searchSubmitted: PropTypes.func,
    isSearch: PropTypes.bool,
    isTotalCount: PropTypes.bool,
    totalCountText: PropTypes.string
};

export default Actions